var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 538.021,
    height: 277.371,
    viewBox: "0 0 538.021 277.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_teamwork_hpdk",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    d: "M688.971,680.081H152.377a.714.714,0,0,1,0-1.429H688.969a.714.714,0,0,1,0,1.429Z",
    transform: "translate(-151.662 -402.771)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(164.337 26.709)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(148.872 26.709)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(133.408 26.709)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(117.943 26.709)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(164.337 42.909)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(148.872 42.909)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(133.408 42.909)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(117.943 42.909)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(164.337 59.11)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(148.872 59.11)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(133.408 59.11)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(117.943 59.11)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(164.337 75.31)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(133.408 75.31)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(117.943 75.31)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(148.872 75.31)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(164.337 91.511)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(148.872 91.511)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(133.408 91.511)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(117.943 91.511)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(164.337 107.711)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(148.872 107.711)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(133.408 107.711)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(117.943 107.711)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M375.19,576.264v1.2a7.507,7.507,0,0,0,7.5,7.5h54a7.5,7.5,0,0,0,7.5-7.5v-1.2a7.446,7.446,0,0,0-1.74-4.8,7.717,7.717,0,0,0-1.266-1.2s-29.689-.672-29.689-1.5H382.69A7.511,7.511,0,0,0,375.19,576.264Z",
    transform: "translate(-241.069 -358.818)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 7.8,
    height: 50.401,
    transform: "translate(165.156 225.849)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M441.716,673.794c0,.843-11.82.326-26.4.326s-26.4.517-26.4-.326,11.82-7.526,26.4-7.526S441.716,672.951,441.716,673.794Z",
    transform: "translate(-246.559 -397.817)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M438.106,535.605a6.446,6.446,0,0,0-2.284-9.616l-16.532-56.333L406.7,475.822l20.209,53.435a6.481,6.481,0,0,0,11.2,6.349Z",
    transform: "translate(-253.673 -319.176)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M420.8,469.874l-14.09,3.814a2.89,2.89,0,0,1-3.625-2.451l-1.7-14.453a8.027,8.027,0,1,1,15.508-4.149l5.8,13.294a2.89,2.89,0,0,1-1.894,3.945Z",
    transform: "translate(-251.434 -309.986)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M313.515,437.383h7.356l3.5-19.078H313.514Z",
    transform: "translate(-125.4 -167.314)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M462.051,664.962h14.487a9.232,9.232,0,0,1,9.232,9.232v.3H462.052Z",
    transform: "translate(-275.812 -397.295)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M446.277,605.607q-.129,0-.258-.012l-10.18-.741a2.7,2.7,0,0,1-2.286-3.618l13.624-30.61a2.1,2.1,0,0,0-.118-1.679,2.07,2.07,0,0,0-1.327-1.056c-6.406-1.675-22.844-6.134-37.073-11.351-6.1-2.235-9.936-5.466-11.412-9.6a13.552,13.552,0,0,1,1.056-10.633l.1-.163,13.389,1.217,14.515,1.235,31.809,17.057a12.052,12.052,0,0,1,5.291,15.471l-14.665,32.886a2.7,2.7,0,0,1-2.464,1.6Z",
    transform: "translate(-249.623 -345.769)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 14.737,
    cy: 14.737,
    r: 14.737,
    transform: "translate(149.758 101.556)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M306.515,436.383h7.356l3.5-19.078H306.514Z",
    transform: "translate(-122.6 -166.914)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M455.051,663.962h14.487a9.232,9.232,0,0,1,9.232,9.232v.3H455.051Z",
    transform: "translate(-273.012 -396.895)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M439.277,608.607q-.129,0-.258-.012l-10.18-.741a2.7,2.7,0,0,1-2.286-3.618l13.624-30.61a2.1,2.1,0,0,0-.118-1.679,2.07,2.07,0,0,0-1.327-1.056c-6.406-1.675-22.844-6.134-37.073-11.351-6.1-2.235-9.936-5.466-11.412-9.6a13.552,13.552,0,0,1,1.056-10.633l.1-.164,13.389,1.217,14.515,1.235,31.809,17.057a12.052,12.052,0,0,1,5.291,15.471l-14.665,32.885a2.7,2.7,0,0,1-2.464,1.6Z",
    transform: "translate(-246.823 -346.969)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M417.188,447.568l-15.6-5.4s-9.794,7.524-5.089,26.19a46.209,46.209,0,0,1-2.04,28.993,29.868,29.868,0,0,1-1.571,3.319s17.4,21,33.6,5.4l-6.3-30.3S430.088,455.668,417.188,447.568Z",
    transform: "translate(-248.148 -308.182)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M413.151,412.031c-2.1-3.139-3.753-7.493-1.443-10.48,2.279-2.949,6.775-2.514,10.267-3.819,4.863-1.817,7.683-7.53,6.8-12.646s-4.986-9.357-9.879-11.092a21.389,21.389,0,0,0-15.2.827,23.211,23.211,0,0,0-13.079,13.246c-2.121,6.028-.987,13.265,3.414,17.9,4.718,4.967,12.124,6.291,18.974,6.211",
    transform: "translate(-246.827 -280.499)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M360.576,388.091c-2.643,2.152-6.675,1.2-9.512-.692s-5.139-4.577-8.209-6.058c-5.412-2.61-11.955-.875-17.222,2.016s-9.936,6.885-15.5,9.154-12.663,2.381-16.875-1.9a15.44,15.44,0,0,0,22.627,18.223c6.1-3.713,9.463-11.5,16.3-13.548,3.783-1.134,7.846-.221,11.67.769s7.811,2.058,11.67,1.216,7.468-4.31,6.977-8.229Z",
    transform: "translate(-207.96 -283.339)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M485.189,603.04a100.507,100.507,0,0,1,0-30.586,2.582,2.582,0,0,1,2.542-2.164h23.924a2.548,2.548,0,0,1,2.013.976,2.591,2.591,0,0,1,.484,2.223,61.4,61.4,0,0,0,0,28.516,2.591,2.591,0,0,1-.484,2.223,2.548,2.548,0,0,1-2.013.976H487.731A2.582,2.582,0,0,1,485.189,603.04Z",
    transform: "translate(-284.599 -359.428)",
    fill: "#57bf9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M508.239,592.1H495.685a1.8,1.8,0,0,1-1.8-1.8v-.7a1.8,1.8,0,0,1,1.8-1.8H508.24a1.8,1.8,0,0,1,1.8,1.8v.7a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(-288.545 -366.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M508.239,604.442H495.685a1.8,1.8,0,0,1-1.8-1.8v-.7a1.8,1.8,0,0,1,1.8-1.8H508.24a1.8,1.8,0,0,1,1.8,1.8v.7a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(-288.545 -371.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M466.226,535.633a6.446,6.446,0,0,0-4.614-8.741l-30.082-50.416-10.649,9.115L453.8,532.283a6.481,6.481,0,0,0,12.427,3.35Z",
    transform: "translate(-259.345 -321.905)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M433.184,476.9l-12.69,7.213a2.89,2.89,0,0,1-4.123-1.468l-5.26-13.569a8.027,8.027,0,0,1,13.979-7.892l8.942,11.422a2.89,2.89,0,0,1-.848,4.294Z",
    transform: "translate(-255.022 -314.156)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M508.637,519.614H265.03a3.9,3.9,0,1,0,0,7.8h6.9v84.9a3.9,3.9,0,1,0,7.8,0V534.908l43.724,79.249a3.9,3.9,0,1,0,6.755-3.9L284.5,527.414H493.337v.05l-45.679,82.793a3.9,3.9,0,1,0,6.755,3.9l38.924-70.549v68.708a3.9,3.9,0,1,0,7.8,0V529.47l1.135-2.056h6.366a3.9,3.9,0,1,0,0-7.8Z",
    transform: "translate(-195.447 -339.158)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 51.602,
    height: 4.2,
    rx: 2.1,
    transform: "translate(162.885 178.055)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M520.432,497.815h-53.4a3.9,3.9,0,0,1-3.9-3.9v-29.4a3.9,3.9,0,0,1,3.9-3.9h53.4a3.9,3.9,0,0,1,3.9,3.9v29.4A3.9,3.9,0,0,1,520.432,497.815Z",
    transform: "translate(-276.244 -315.56)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 3.6,
    cy: 3.6,
    r: 3.6,
    transform: "translate(213.887 160.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M626.55,328.681v-105.3a4.518,4.518,0,0,1,4.513-4.513H714.3a4.518,4.518,0,0,1,4.513,4.513v105.3a4.518,4.518,0,0,1-4.513,4.513H631.063A4.518,4.518,0,0,1,626.55,328.681Zm4.513-108.813a3.514,3.514,0,0,0-3.51,3.51v105.3a3.514,3.514,0,0,0,3.51,3.51H714.3a3.514,3.514,0,0,0,3.51-3.51v-105.3a3.514,3.514,0,0,0-3.51-3.51Z",
    transform: "translate(-341.609 -218.864)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M711.215,283.544V261.922a2.259,2.259,0,0,1,2.256-2.257h18.323a2.259,2.259,0,0,1,2.257,2.257v21.622a2.259,2.259,0,0,1-2.257,2.257H713.471a2.259,2.259,0,0,1-2.257-2.256Z",
    transform: "translate(-375.473 -235.184)",
    fill: "#57bf9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M651.88,300.258V278.636a2.259,2.259,0,0,1,2.256-2.257h18.323a2.259,2.259,0,0,1,2.256,2.257v21.622a2.259,2.259,0,0,1-2.256,2.257H654.136A2.259,2.259,0,0,1,651.88,300.258Z",
    transform: "translate(-351.741 -241.869)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M699.515,351.237V329.615a2.259,2.259,0,0,1,2.256-2.257h18.323a2.259,2.259,0,0,1,2.256,2.257v21.622a2.259,2.259,0,0,1-2.256,2.257H701.771a2.259,2.259,0,0,1-2.257-2.256Z",
    transform: "translate(-370.794 -262.26)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(464.578 3.212)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(464.578 18.677)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(464.578 34.141)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(464.578 49.606)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(448.378 3.212)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(448.378 18.677)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(448.378 34.141)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(448.378 49.606)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(432.177 3.212)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(432.177 18.677)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(432.177 34.141)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(432.177 49.606)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(415.977 3.212)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(415.977 18.677)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(415.977 34.141)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(415.977 49.606)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(399.776 3.212)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(399.776 18.677)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(399.776 34.141)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(399.776 49.606)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(383.576 3.212)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(383.576 18.677)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(383.576 34.141)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 3.88,
    cy: 3.88,
    r: 3.88,
    transform: "translate(383.576 49.606)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M823.191,428.268a6.6,6.6,0,0,1,4.661-8.679,6.362,6.362,0,0,1,.871-.142l14.582-25.56-3.682-6.326,9.166-7.071,7.012,9.739a6.689,6.689,0,0,1-.156,7.985l-20.02,25.629a6.3,6.3,0,0,1,.186.621,6.6,6.6,0,0,1-5.616,8.094,6.421,6.421,0,0,1-.808.051A6.622,6.622,0,0,1,823.191,428.268Z",
    transform: "translate(-420.103 -283.512)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M617.144,431.973h-7.356l-3.5-28.374h10.857Z",
    transform: "translate(-242.504 -161.432)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M597.408,447.384H611.6v8.932H588.476A8.932,8.932,0,0,1,597.408,447.384Z",
    transform: "translate(-235.38 -178.945)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M718.144,431.973h-7.356l-3.5-28.374h10.857Z",
    transform: "translate(-282.903 -161.432)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M698.408,447.384H712.6v8.932H689.476A8.932,8.932,0,0,1,698.408,447.384Z",
    transform: "translate(-275.778 -178.945)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M855.556,373.53l-16.515,6.276-4.032-11.2a6.7,6.7,0,0,1,3-8.1h0a6.7,6.7,0,0,1,8.558,1.671Z",
    transform: "translate(-424.83 -275.169)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M766.319,556.305l-13.851-3.159a2.992,2.992,0,0,1-2.287-3.372c5.558-35.227,10.9-55.856,24.685-82.054.192-.488,2.344-10.4,3.748-16.972a2.983,2.983,0,0,1,2.528-3.014l25.827-3.975a3.342,3.342,0,0,1,1.213-.183l.258.049,0,.254c0,.263-.265.3-.363.318l-.343.053a4.009,4.009,0,0,1,1.065.724c11.316,13.611,17.2,58.226,24.674,107.514a2.691,2.691,0,0,1-.782,2.189,2.96,2.96,0,0,1-2.123.96l-16.5.4a2.99,2.99,0,0,1-3.021-2.531l-11.115-64.232a2.385,2.385,0,0,0-4.5-.693c-8.967,18.261-17.329,34.054-25.565,65.562a2.972,2.972,0,0,1-2.876,2.236,3.021,3.021,0,0,1-.673-.076Z",
    transform: "translate(-391.045 -308.745)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M798.053,417.72a3,3,0,0,1-1.25-2.129c-2.115-19.746-.642-35.2,4.5-47.242a15,15,0,0,1,9.94-8.508l13.35-.674.069.033a15.6,15.6,0,0,1,8.532,16.554c-4.294,11.318-7.889,23.1-5.147,32.609a3.073,3.073,0,0,1-.29,2.39,2.93,2.93,0,0,1-1.869,1.385l-25.428,6.049a2.979,2.979,0,0,1-2.41-.466Z",
    transform: "translate(-409.334 -274.982)",
    fill: "#57bf9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M767.04,387.5l-25.605-20.2a6.3,6.3,0,0,1-.622.183,6.616,6.616,0,0,1-5.291-1.015,6.548,6.548,0,0,1-2.776-4.64,6.6,6.6,0,0,1,12.982-2.281,6.34,6.34,0,0,1,.137.871l25.49,14.7,6.343-3.652,7.027,9.2-9.849,7.02a6.565,6.565,0,0,1-7.836-.191Z",
    transform: "translate(-384.068 -273.098)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M814.872,387.924l-14.61-9.935,6.866-9.724a6.7,6.7,0,0,1,8.357-2.184h0a6.7,6.7,0,0,1,3.537,7.97Z",
    transform: "translate(-411.091 -277.487)",
    fill: "#57bf9a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 14.737,
    cy: 14.737,
    r: 14.737,
    transform: "translate(396.071 49.724)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M817.065,310.515c-3.788,2.592-8.761,5.257-12.63,2.5a7.04,7.04,0,0,1-2.31-8.115c1.852-5.3,6.942-7.629,11.809-9.417,6.327-2.324,13.216-4.173,19.747-2.508s12.3,7.988,11.125,14.624c-.948,5.337-5.982,9.777-5.268,15.15.719,5.407,6.8,8.254,12.169,9.22s11.377,1.277,15.235,5.133c4.922,4.919,3.693,13.712-.939,18.906s-11.62,7.548-18.393,9.149c-8.973,2.121-18.678,3.235-27.2-.284s-15.154-12.993-12.685-21.877c1.043-3.752,3.5-6.924,5.873-10.011s4.778-6.316,5.684-10.1a10.5,10.5,0,0,0-1.9-9.189,2.662,2.662,0,0,1-.357-3.112Z",
    transform: "translate(-411.661 -248.25)",
    fill: "#2f2e41"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGraph);
export default __webpack_public_path__ + "static/media/leftGraph.30f33f8d.svg";
export { ForwardRef as ReactComponent };